export default __webpack_public_path__ + "static/media/kick-out.e21c3808.svg";